
import { defineComponent, onMounted, reactive } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";

import Legalitas from "@/components/1crm/1sekolah/legalitas/legalitas.vue";
import UploadComponent from "@/components/1crm/1sekolah/legalitas/upload-modal.vue";
import DraftTemplate from "@/components/1crm/1sekolah/legalitas/draft-template.vue";

export default defineComponent({
  name: "kt-widget-11",
  components: {
    Legalitas,
    UploadComponent,
    DraftTemplate,
  },
  props: {
    widgetClasses: String,
  },

  beforeMount() {
    store.dispatch(Actions.VERIFY_AUTH);

    setCurrentPageBreadcrumbs("Legalitas", ["Data"]);
  },
});
